import { render, staticRenderFns } from "./UpsellItem.vue?vue&type=template&id=784936bd&scoped=true"
import script from "./UpsellItem.vue?vue&type=script&lang=js"
export * from "./UpsellItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784936bd",
  null
  
)

export default component.exports